import { subDays, subYears } from "date-fns/fp";
export var DATE_OPTIONS = [
    { value: 'last_seven_days', label: 'Last 7 Days', },
    { value: 'last_thirty_days', label: 'Last 30 Days' },
    { value: 'last_180_days', label: 'Last 180 Days' },
    { value: 'last_year', label: 'Last Year' },
    { value: 'last_two_years', label: 'Last 2 Years' },
    { value: 'last_three_years', label: 'Last 3 Years' },
    { value: 'all_time', label: 'All-time' },
];
function dateFromOptionKey(key, today) {
    if (today === void 0) { today = new Date(); }
    switch (key) {
        case 'last_seven_days':
            return subDays(7, today);
        case 'last_180_days':
            return subDays(180, today);
        case 'last_year':
            return subYears(1, today);
        case 'last_two_years':
            return subYears(2, today);
        case 'last_three_years':
            return subYears(3, today);
        case 'all_time':
            // Jan 1, 2005 00:00:00
            return new Date(2005, 0, 1, 0, 0);
        case 'last_thirty_days':
        default:
            return subDays(30, today);
    }
}
export { dateFromOptionKey };
